/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import { useRef } from "react";
import classes from "./ThousandPropertiesNewRails.module.scss";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import wrapperHOC from "@Utils/wrapperHOC";
import useWhitelabel from "hooks/useWhitelabel";
import PillsSelector from "./PillsSelector";
import Header from "./components/Header";
import ContentRenderer from "./components/ContentRenderer";
import SSRContentRenderer from "./components/SSRContentRenderer";
import { useThousandProperties } from "./hooks/useThousandProperties";
import { CollectionRailProps } from "./types";
import { SCREEN_SIZE, useResponsiveness } from "hooks/useResponsiveness";

const ThousandPropertiesNewRails: React.FC<CollectionRailProps> = ({
  collection = [],
  fetchData,
  title,
  subTitle,
  showSeeMoreCard = true,
  greyBg = false,
  gtagEventAction = "inventory_clicked",
  gtagEventActionPill = null,
  gtagEventCategory = "HOME",
  recentlyViewedCityCanonical = "",
  subSectionPaddingReduced,
  isDesktop = false,
  isShowPills = true,
  id = "",
  showSeeAll = false,
  countryCityMapping = [],
  thousandProperties,
}) => {
  const {
    isWhitelabel,
    whitelabel_region_canonical_name,
    whitelabelConfig,
    isDemoSubdomain,
    partner_uuid,
  } = useWhitelabel();

  const countryMenuRef = useRef<HTMLDivElement>(null);

  const {
    activeCountry,
    setActiveCountry,
    pills,
    setPills,
    isCountryMenuOpen,
    setIsCountryMenuOpen,
    activePill,
    activePillCanonical,
    isRequestActive,
    collectionState,
    displayCollection,
    handleExploreMore,
    fetchCityUniData,
    getSSRDisplayCollection,
    getHiddenSSRData,
    domesticCountry,
  } = useThousandProperties({
    collection,
    showSeeMoreCard,
    isDesktop,
    isShowPills,
    countryCityMapping,
    thousandProperties,
    gtagEventActionPill,
    fetchData,
    isWhitelabel,
    whitelabelConfig,
    whitelabel_region_canonical_name,
    isDemoSubdomain,
    partner_uuid,
    recentlyViewedCityCanonical,
  });
  const { isAbove } = useResponsiveness();
  const isAboveMD = isAbove(SCREEN_SIZE.MD, false);
  const showForDesktop = isDesktop && isAboveMD;

  return (
    <>
      <div
        data-testid={title}
        className={formatClassNames(
          !showForDesktop && subSectionPaddingReduced ? classes.collectionRailPaddingReduced : {},
          classes.sectionContainer,
          greyBg ? classes.greyBg : {},
          showForDesktop && classes.desktop,
          !isShowPills && classes.withOutPills,
        )}
        id={id}
      >
        <Header
          title={title}
          subTitle={subTitle}
          isDesktop={showForDesktop}
          showSeeAll={showSeeAll}
          isWhitelabel={isWhitelabel}
          handleExploreMore={handleExploreMore}
        />
        <div
          className={formatClassNames(
            classes.carouselPart,
            isDesktop && classes.carouselPartDesktop,
          )}
        >
          <PillsSelector
            pills={pills}
            activePill={activePill}
            activeCountry={activeCountry}
            isCountryMenuOpen={isCountryMenuOpen}
            isDesktop={isDesktop}
            isWhitelabel={isWhitelabel}
            isShowPills={isShowPills}
            countryCityMapping={countryCityMapping}
            countryMenuRef={countryMenuRef}
            setIsCountryMenuOpen={setIsCountryMenuOpen}
            setActiveCountry={setActiveCountry}
            setPills={setPills}
            fetchCityUniData={fetchCityUniData}
            domesticCountry={domesticCountry}
          />
          {__CLIENT__ ? (
            <ContentRenderer
              isRequestActive={isRequestActive}
              collectionState={collectionState}
              displayCollection={displayCollection}
              title={title}
              gtagEventAction={gtagEventAction}
              gtagEventCategory={gtagEventCategory}
              isDesktop={isDesktop}
              activePillCanonical={activePillCanonical}
              handleExploreMore={handleExploreMore}
              isWhitelabel={isWhitelabel}
            />
          ) : (
            <SSRContentRenderer
              title={title}
              gtagEventAction={gtagEventAction}
              gtagEventCategory={gtagEventCategory}
              isDesktop={isDesktop}
              isRequestActive={isRequestActive}
              getSSRDisplayCollection={getSSRDisplayCollection}
              getHiddenSSRData={getHiddenSSRData}
            />
          )}
        </div>
      </div>
      {!showForDesktop && <div className={classes.bottomBorder} />}
    </>
  );
};

export default wrapperHOC(ThousandPropertiesNewRails, {
  componentName: "ThousandPropertiesNewRails-Home",
  showForChina: true,
});
